// Pending-deletes registry. Each entry: a window-timer about to call
// api.deleteMessage, plus a `restore` thunk that reads the original
// message from a closure. Keyed by message id so toast-undo and
// channel-switch both can find + flush a delete in flight.
const PENDING_DELETES = new Map<
  string,
  { timer: number; restore: () => void }
>();

/** Register a delete-in-flight for `id` so the toast's "Отменить" can find it. */
export function registerPendingDelete(
  id: string,
  entry: { timer: number; restore: () => void },
): void {
  PENDING_DELETES.set(id, entry);
}

/** Drop the registry entry for `id` (used when the timer fires for real). */
export function clearPendingDelete(id: string): void {
  PENDING_DELETES.delete(id);
}

/** Cancel a pending delete for `id`: clears its timer, drops the entry, and
 *  runs the stored `restore` thunk so the bubble comes back. No-op when there
 *  is no entry (already flushed). */
export function cancelPendingDelete(id: string): void {
  const entry = PENDING_DELETES.get(id);
  if (!entry) return;
  window.clearTimeout(entry.timer);
  PENDING_DELETES.delete(id);
  entry.restore();
}
